import React from "react";
import { Stack, Text } from "@mantine/core";
import styles from "./InfoTooltip.module.css";

export interface MetricInfoProps {
  /** Plain-language description of the metric. */
  description?: string | null;
  /** Human-readable formula (metric names only, never variables). */
  formula?: string | null;
}

/**
 * Tooltip body for a report metric: its plain-language description and, when
 * present, its formula. Both strings come from the report definition — the
 * portal never hard-codes metric copy. Renders nothing when both are empty.
 */
export default function MetricInfo({ description, formula }: MetricInfoProps) {
  if (!description && !formula) return null;
  return (
    <Stack gap="xs">
      {description && (
        <Text component="span" className={styles.description}>
          {description}
        </Text>
      )}
      {formula && (
        <Stack gap={2}>
          <Text component="span" className={styles.formulaLabel}>
            Formula
          </Text>
          <Text component="span" className={styles.formula}>
            {formula}
          </Text>
        </Stack>
      )}
    </Stack>
  );
}
